module.exports = __webpack_public_path__ + "assets/img/vertical-support-bar-tube.64a52a35.png";